import React, { Component } from 'react';
import "./contact.css"

export default  class Contact extends Component {
  render() {
    return (
        <div id="contact-wrapper">
            <div id="contact-container">
                <h1>Let's get in touch</h1>
                <p>Thank you for finding the time to visit my personal website. If you found anything interesting then do not hesitate to reach out to my.</p>

                <ul>
                    <li><strong>E-mail :</strong> <a href = "mailto:mathiesenmarcus@gmail.com?">mathiesenmarcus@gmail.com</a></li>
                    <li><strong>Phone:</strong> +45 61 40 91 87</li>
                    <li><strong>Address:</strong> Bragesgade 2, 4. tv, 2200 Copenhagen, Denmark</li>
                </ul>
            </div>
        </div>
    );
  }
}